import moment from "moment";
import {
  SALES_REPORT_EXPORT_NAMES,
  useSalesReportExportMutation,
} from "../../../../../../../../api/mutations/useSalesReportExportMutation";
import { FILE_EXPORT_TYPES } from "../../../../../../../../consts/api";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../../services/UINotificationService";
import { composeDownloadDataUrl } from "../../../../../../../../utilities/api";

export function useDownloadExcel({ filter } = {}) {
  const { tCommon } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useSalesReportExportMutation({
    onError: () => {
      uiNotification.error(tCommon("error.exportXlsReports"));
    },
  });

  const initiate = async () => {
    let fromDate = null;
    let toDate = null;

    if (filter?.type === "days" && typeof filter.days === "number") {
      fromDate = moment().toDate();
      toDate = moment().add(filter.days, "days").toDate();
    } else if (filter?.type === "range" && filter?.from && filter?.to) {
      fromDate = moment(filter.from).toDate();
      toDate = moment(filter.to).toDate();
    }

    const res = await mutateAsync({
      type: FILE_EXPORT_TYPES.xls,
      name: SALES_REPORT_EXPORT_NAMES.expiringLiabilityReport,
      fromDate,
      toDate,
    });

    window.open(composeDownloadDataUrl(res.fileName), "_blank");
  };

  return {
    initiate,
    isLoading,
  };
}
